import { NgFor, AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Observable } from 'rxjs';
import { CatalogItemVM } from 'src/app/models/catalog-item.model';

import { CatalogProductDescriptionComponent } from '../catalog-product-description/catalog-product-description.component';

@Component({
  selector: 'app-catalog-product-grid',
  templateUrl: './catalog-product-grid.component.html',
  styleUrls: ['./catalog-product-grid.component.scss'],
  imports: [NgFor, CatalogProductDescriptionComponent, MatButton, MatIcon, AsyncPipe],
})
export class CatalogProductGridComponent {
  @Input() data: Observable<CatalogItemVM[]>;
  @Output() readonly addToCartClicked: EventEmitter<CatalogItemVM> = new EventEmitter();
  @Output() readonly descriptionClicked: EventEmitter<CatalogItemVM> = new EventEmitter();
}
